export type ExternalAgentId =
  | 'cursor'
  | 'claude-code'
  | 'codex'
  | 'lovable'
  | 'replit';

export interface ExternalAgent {
  /* Stable ID for each agent */
  id: ExternalAgentId;
  /* Name of the agent for display, not stable and may change */
  name: string;
}

const externalAgents: ExternalAgent[] = [
  {id: 'cursor', name: 'Cursor'},
  {id: 'claude-code', name: 'Claude Code'},
  {id: 'codex', name: 'Codex'},
  {id: 'lovable', name: 'Lovable'},
  {id: 'replit', name: 'Replit'},
];

export const useExternalAgents = () => {
  return externalAgents;
};
